import { createSelector } from 'reselect';

const stateSelector = state => state.atg__bet;

export const getCurrentBetId = createSelector(
  stateSelector,
  bet => bet.currentBetId,
);

export const getPresetBetBasedAt = createSelector(
  stateSelector,
  bet => bet.presetBetBasedAt,
);

export const isQuickOverviewLoading = createSelector(
  stateSelector,
  bet => bet.quickOverview.isLoading,
);

export const getQuickOverviewData = createSelector(
  stateSelector,
  bet => bet.quickOverview.data,
);

export const getQuickOverviewError = createSelector(
  stateSelector,
  bet => bet.quickOverview.error,
);
